<div class="plan-members-item">
  <div class="inner">
    <div class="name"><ng-content></ng-content></div>
    <button class="btn-close" *ngIf="isDeletable" matRipple [matRippleUnbounded]="true" [matRippleRadius]="30">
      <mat-icon class="icon">highlight_off</mat-icon>
    </button>
  </div>
</div>
